import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const ProductDetailOpticsFeatures = ({ frame , antiReflex , antiScratch  })=>/*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-optics-features"
    }, !!frame && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), frame), !!antiReflex && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiReflex), antiScratch && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiScratch))
;
var ProductDetailOpticsFeatures$1 = ProductDetailOpticsFeatures;

export { ProductDetailOpticsFeatures$1 as default };
//# sourceMappingURL=ProductDetailOpticsFeatures.js.map
